import { memo, useEffect, useState } from "react";
import destinationIcon from "../assets/images/destinationimg.svg";
import { useFieldArray } from "react-hook-form";
import { Container, enquiryStore } from "../enquiry/enquiry-data";
import { containerTypeList, containerTypeListTC, maxWeightPerContainerFcl } from "../StaticData";
import { Quantity } from "../tailwind-components/Quantity";
import { TextWithSelect } from "../mui-components/TextWithSelect";
import { AgMuiSelect2 } from "../mui-components/Controlled";
import { Add } from "@mui/icons-material";
import deleteicon from "../assets/images/deletei.svg";
import { FlexibleCenteredDiv } from "./AgFlexibleCenteredDiv";
import { TableHeading } from "./AgTableHeading";
import { HeadingWithSelect } from "./AgHeadingWithSelect";
import { useSnapshot } from "valtio";
import { AgmodalStore, filtersState, loginStore } from "../state/CommonState";
import { useGlobalState } from "../GlobalState";
import { taskStore } from "../mytasks/task-store";
import { useMobile } from "../hooks/usemobile";
import { AgMobileUnitsBox } from "./AgMobileUnitsBox";

const MobileViewSingleComponentLayout = ({ title, children, width = "100%" }) => (
    <div className={`flex flex-col gap-1`} style={{ width }}>
        <span className="text-[#2C358A] font-semibold text-xs">{title}</span>
        {children}
    </div>
);

export const ContainerTypeComponent = memo(({ form, viewonly, i, containerdetail, generateId, typeList }) => {
    const { control } = form;
    const isMobile = useMobile();
    return (
        <AgMuiSelect2
            onChangeHandler={() => {
                filtersState.initialize();
            }}
            disabled={viewonly}
            key={generateId(containerdetail.id, i)}
            style={{ height: "25px", width: isMobile ? "100%" : "170px" }}
            rules={{
                validate: (value) => {
                    if (!value || value.length === 0) {
                        enquiryStore.isForEnquiry = false;
                        return "Required";
                    } else {
                        enquiryStore.isForEnquiry = true;
                    }
                }
            }}
            width={isMobile?"100%":"170px"}
            size="small"
            fontSize="12px"
            options={typeList}
            control={control}
            name={`containerDetails.${i}.containerType`}
        />
    );
});

export const ContainerQuantityComponent = memo(({ form, viewonly, i, containerdetail, generateId, validateGreaterThanZero }) => {
    const { control, setValue } = form;
    const isMobile = useMobile();
    return (
        <Quantity
            width={isMobile ? "100%" : "90px"}
            onChange={() => {
                filtersState.initialize();
            }}
            disabled={viewonly}
            key={generateId(containerdetail.id, i)}
            control={control}
            callback={(e) => {
                setValue(`containerDetails.${i}.numContainers`, e);
            }}
            name={`containerDetails.${i}.numContainers`}
            rules={{
                required: "Required",
                validate: (value) => {
                    const isValue = validateGreaterThanZero(value);
                    if (!isValue) return;
                    if (typeof isValue === "string") {
                        enquiryStore.isForEnquiry = false;
                        return isValue;
                    } else {
                        enquiryStore.isForEnquiry = true;
                    }
                }
            }}
        />
    );
});

export const WeightPerContainerComponent = memo(({ form, viewonly, i, containerdetail, generateId, weightPerContainer, isNavexel, currentMenu }) => {
    const { control, getValues } = form;
    const isMobile = useMobile();
    return (
        <TextWithSelect
            textFieldWidth={isMobile ? "100%" : "170px"}
            onChange={() => {
                filtersState.initialize();
            }}
            rules={{
                required: "Required",
                validate: (value) => {
                    let containerType = getValues(`containerDetails.${i}.containerType`);
                    if (parseFloat(value) <= 0) {
                        return "Invalid value";
                    }
                    if (!containerType) {
                        return;
                    }
                    let maxValue = maxWeightPerContainerFcl[containerType]?.[weightPerContainer?.toLowerCase()];
                    if (maxValue && parseFloat(value) > maxValue) {
                        return `value can't be greater than ${maxValue} ${weightPerContainer}.`;
                    }
                    return;
                }
            }}
            key={generateId(containerdetail.id, i)}
            options={["Kgs", "Tons", "Lbs"]}
            control={control}
            name={`containerDetails.${i}.wtPerContainer`}
            unit={weightPerContainer}
            disabled={viewonly}
        />
    );
});

export function MultiContainerDetails({ form, viewonly, ind }) {
    const { currentMenu } = useGlobalState();
    const isNavexel = process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE;
    const { control, watch, getValues, resetField, setValue } = form;
    const isMobile = useMobile();
    const { fields: containerDetails, append: appendContainer, remove: removeContainer } = useFieldArray({
        control: control,
        name: `containerDetails`
    });
    const [dis, setDis] = useState(false);
    useSnapshot(AgmodalStore);
    const [typeList, setTypeList] = useState(containerTypeList);
    let containerDetailsFromForm = watch(`containerDetails`);
    const temperatureControlled = watch("temperatureControlled");
    const stuffingType = watch("stuffingType");
    const showCargoDetailsOutGuage = watch("showCargoDetailsOutGuage");
    const destuffingType = watch("destuffingType");
    const weightPerContainer = getValues("containerDetails.0.unit");
    const containerTypes = ["20'OT (Out-gauge)", "40'OT (Out-gauge)", "20'FR (Out-gauge)", "40'FR (Out-gauge)"];

    useEffect(() => {
        if (!dis && taskStore.current.actionName == 'Booking Amendment') {
            setDis(true);
        }
        if (viewonly) {
            if (!dis) {
                setDis(true);
            }
        } else {
            if (dis) {
                setDis(false);
            }
        }
    }, [AgmodalStore]);

    useEffect(() => {
        let l = false;
        for (let i = 0; i < containerDetailsFromForm.length; i++) {
            let k = containerDetailsFromForm[i];
            if (k["numContainers"] == undefined) {
                setValue(`containerDetails.${i}.numContainers`, 0);
            }
            if (k["wtPerContainer"] == undefined) {
                setValue(`containerDetails.${i}.wtPerContainer`, 0);
            }
        }
        if (containerDetailsFromForm != undefined) {
            for (let j = 0; j < containerDetailsFromForm.length; j++) {
                if (l == false) {
                    l = containerTypes.includes(containerDetailsFromForm[j]['containerType']);
                }
            }
        }
        if (showCargoDetailsOutGuage != l) {
            setValue('showCargoDetailsOutGuage', l);
        }
    }, [JSON.stringify(containerDetailsFromForm)]);

    const generateId = (id, i) => {
        if (id == undefined) {
            let a = i + Date.now() + '-' + Math.floor(Math.random() * 1000);
            containerDetailsFromForm[i].id = a;
            return a;
        } else {
            return id;
        }
    };

    useEffect(() => {
        for (let i = 1; i < containerDetailsFromForm.length; i++) {
            setValue(`containerDetails.${i}.unit`, weightPerContainer);
        }
    }, [weightPerContainer]);

    useEffect(() => {
        if (temperatureControlled) {
            setTypeList(containerTypeListTC);
        } else {
            setTypeList(containerTypeList);
        }
    }, [temperatureControlled, stuffingType, destuffingType]);

    const validateGreaterThanZero = (value) => {
        return parseFloat(value) > 0 || 'Invalid Value';
    };

    return (
        <div className="w-full flex flex-col gap-2 items-end">
            {isMobile ? (
                <div className="w-full flex flex-col gap-3">
                    <AgMobileUnitsBox
                        control={control}
                        dis={dis}
                        showOnlyWeight={true}
                        weightUnitName="containerDetails.0.unit"
                        weightUnitLabel="Weight Per Container *"
                    />
                    {containerDetailsFromForm.map((containerdetail, i) => (
                        <div key={generateId(containerdetail.id, i)} className="w-full flex flex-col gap-3 bg-white rounded-[6px] border border-[#E8E8E8] ">
                            {i > 0 && <div className="w-full border-t border-dotted border-[#D4D4D4] border-b-0 my-1" />}
                            <div className="w-full flex flex-row justify-between items-center">
                                <span className="text-[#2C358A] font-bold text-sm">Row {i + 1}</span>
                                {!viewonly && containerDetails.length > 1 && (
                                    <div
                                        onClick={() => {
                                            filtersState.initialize();
                                            removeContainer(i);
                                        }}
                                        className="w-7 h-7 flex items-center justify-center bg-[#FFEAEA] border border-[#FCA5A5] rounded-[4px] cursor-pointer hover:bg-[#FEE2E2] transition-colors"
                                    >
                                        <img src={deleteicon} alt="delete" className="w-4 h-4" />
                                    </div>
                                )}
                            </div>
                            <div className="w-full flex flex-row gap-2">
                                <MobileViewSingleComponentLayout title="Container Type*" width="70%">
                                    <ContainerTypeComponent
                                        form={form}
                                        viewonly={viewonly}
                                        i={i}
                                        containerdetail={containerdetail}
                                        generateId={generateId}
                                        typeList={typeList}
                                    />
                                </MobileViewSingleComponentLayout>
                                <MobileViewSingleComponentLayout title="Quantity*" width="30%">
                                    <ContainerQuantityComponent
                                        form={form}
                                        viewonly={viewonly}
                                        i={i}
                                        containerdetail={containerdetail}
                                        generateId={generateId}
                                        validateGreaterThanZero={validateGreaterThanZero}
                                    />
                                </MobileViewSingleComponentLayout>
                            </div>
                            <div className="w-full flex flex-row gap-2">
                                <MobileViewSingleComponentLayout title="Weight Per Container*" width="100%">
                                    <WeightPerContainerComponent
                                        form={form}
                                        viewonly={viewonly}
                                        i={i}
                                        containerdetail={containerdetail}
                                        generateId={generateId}
                                        weightPerContainer={weightPerContainer}
                                        isNavexel={isNavexel}
                                        currentMenu={currentMenu}
                                    />
                                </MobileViewSingleComponentLayout>
                            </div>
                        </div>
                    ))}
                    {!viewonly && (
                        <button
                            onClick={() => {
                                filtersState.initialize();
                                let newContainer = new Container();
                                newContainer.unit = weightPerContainer;
                                appendContainer({ ...newContainer });
                            }}
                            type="button"
                            className="w-full h-[40px] flex flex-row gap-[6px] justify-center items-center font-bold bg-[#F5F8FF] border-[1px] border-dashed border-[#5A78FA] rounded-[6px] text-[#2C358A] cursor-pointer hover:bg-[#EBF2FF] transition-colors mt-1"
                        >
                            <Add sx={{ fontSize: "20px", color: "#2C358A" }} />
                            <span className="text-[#2C358A] font-semibold text-sm">Add Row</span>
                        </button>
                    )}
                </div>
            ) : (
                <div className="flex flex-col w-full">
                    <div className={`flex flex-row w-full h-[35px] items-center border-[0.5px] border-solid border-[#D4D4D4] border-b-0 px-[12px]`}>
                        <FlexibleCenteredDiv>
                            <TableHeading title="Container Type *" />
                        </FlexibleCenteredDiv>
                        <FlexibleCenteredDiv>
                            <TableHeading title="Number of Containers *" />
                        </FlexibleCenteredDiv>
                        <FlexibleCenteredDiv>
                            <HeadingWithSelect
                                key={weightPerContainer}
                                onDropdownChange={() => {
                                    filtersState.initialize();
                                }}
                                options={["Kgs", "Tons", "Lbs"]}
                                heading={"Weight Per Container *"}
                                control={control}
                                name={`containerDetails.0.unit`}
                                disabled={dis}
                            />
                        </FlexibleCenteredDiv>
                        {containerDetails.length > 1 && <div className="w-[35px] h-full"></div>}
                    </div>
                    {containerDetailsFromForm.map((containerdetail, i) => (
                        <div
                            key={generateId(containerdetail.id, i)}
                            className={`flex flex-row w-full py-[8px] items-center px-[12px] ${
                                i % 2 === 0 ? "bg-[#F3F3F3]" : "bg-white border-[0.5px] border-solid border-[#D4D4D4]"
                            }`}
                        >
                            <FlexibleCenteredDiv>
                                <ContainerTypeComponent
                                    form={form}
                                    viewonly={viewonly}
                                    i={i}
                                    containerdetail={containerdetail}
                                    generateId={generateId}
                                    typeList={typeList}
                                />
                            </FlexibleCenteredDiv>
                            <FlexibleCenteredDiv>
                                <ContainerQuantityComponent
                                    form={form}
                                    viewonly={viewonly}
                                    i={i}
                                    containerdetail={containerdetail}
                                    generateId={generateId}
                                    validateGreaterThanZero={validateGreaterThanZero}
                                />
                            </FlexibleCenteredDiv>
                            <FlexibleCenteredDiv>
                                <WeightPerContainerComponent
                                    form={form}
                                    viewonly={viewonly}
                                    i={i}
                                    containerdetail={containerdetail}
                                    generateId={generateId}
                                    weightPerContainer={weightPerContainer}
                                    isNavexel={isNavexel}
                                    currentMenu={currentMenu}
                                />
                            </FlexibleCenteredDiv>
                            {!viewonly && containerDetails.length > 1 && (
                                <div
                                    onClick={() => {
                                        filtersState.initialize();
                                        removeContainer(i);
                                    }}
                                    className="w-[35px] h-full flex items-center justify-center cursor-pointer"
                                >
                                    <img src={deleteicon} alt="delete" />
                                </div>
                            )}
                        </div>
                    ))}
                    {!viewonly && (
                        <button
                            onClick={() => {
                                filtersState.initialize();
                                let newContainer = new Container();
                                newContainer.unit = weightPerContainer;
                                appendContainer({ ...newContainer });
                            }}
                            type="button"
                            className="bg-[#F7F7F7] border-[1px] border-solid border-[#E8E8E8] h-[35px] w-[110px] rounded-[6px] self-end mt-2"
                        >
                            <div className="flex h-full w-full flex-row gap-[5px] justify-center items-center font-bold">
                                <Add sx={{ fontSize: "22px", color: process.env.REACT_APP_ENTERPRISE_COLOUR }} />
                                <p className="text-grey">Add Row</p>
                            </div>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}